import { motion } from "framer-motion";
import { ArrowRight, ArrowDown } from "lucide-react";
import { Link } from "react-router-dom";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1474302770737-173ee21bab63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxleGVjdXRpdmUlMjBwcml2YXRlJTIwamV0JTIwZGFya3xlbnwwfHx8fDE3OTE4OTAzMDl8MA&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Private jet on the tarmac at golden hour"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-black/30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pb-28 pt-40 w-full">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-xs uppercase tracking-[0.25em] text-gold mb-6"
          data-testid="hero-overline"
        >
          Private Aviation · Yachts · Bullion
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tight text-white max-w-4xl leading-[1.05]"
          data-testid="hero-heading"
        >
          The discreet club for executive travel &amp; luxury assets
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-8 max-w-xl text-base sm:text-lg text-white/70 font-light leading-relaxed"
          data-testid="hero-subheading"
        >
          Aero Vista Club brings private jet charter, aircraft acquisition,
          yachts and bullion together under one roof — with Vistacoin bridging
          the world of tangible assets and digital currency.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.45 }}
          className="mt-10 flex flex-wrap gap-4"
        >
          <Link
            to="/enquire/charter"
            data-testid="hero-cta-enquire"
            className="group inline-flex items-center gap-3 bg-gold text-black text-xs uppercase tracking-[0.2em] px-8 py-4 rounded-sm transition-colors duration-300 hover:bg-gold-light"
          >
            Request a Flight
            <ArrowRight
              size={14}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </Link>
          <a
            href="#featured"
            data-testid="hero-cta-services"
            className="inline-flex items-center gap-3 border border-white/20 text-white/80 text-xs uppercase tracking-[0.2em] px-8 py-4 rounded-sm transition-colors duration-300 hover:bg-white/5 hover:text-white"
          >
            Explore the Club
          </a>
        </motion.div>
      </div>

      <div className="absolute bottom-8 right-8 hidden lg:flex items-center gap-3 text-white/40">
        <span className="text-[10px] uppercase tracking-[0.25em]">Scroll</span>
        <ArrowDown size={14} className="animate-bounce" />
      </div>
    </section>
  );
};
